<div class="ds-accordion">
  <div>
    <button class="accordion-button" [ngClass]="[size]" [disabled]="disabled" (click)="toggleAccordion()">
      <span class="label" [ngClass]="{ 'w-100': maxWidth }">{{ label }}</span>
      <ds-icon [icon]="isOpen ? 'up-arrow' : 'down-arrow'" class="icon"></ds-icon>
    </button>
  </div>

  <div *ngIf="isOpen" [@slideDown]>
    <ng-content></ng-content>
  </div>
</div>
